import { Product } from "types/product";
import { ManuallyLeadFormValues } from "../../componets/ImportLeadCreateManually";
import { IManuallyLeadFormDto } from "../../service/dto";
import { nullIfEmptyString } from "utils";

export function convertManuallyLeadFormDtoRequest(
    manuallyLeadForm: ManuallyLeadFormValues
): IManuallyLeadFormDto {
    return {
        leadId: manuallyLeadForm.leadId,
        clientTitle: nullIfEmptyString(manuallyLeadForm.clientTitle),
        clientFirstName: nullIfEmptyString(manuallyLeadForm.clientFirstName),
        clientLastName: nullIfEmptyString(manuallyLeadForm.clientLastName),
        clientEmail: nullIfEmptyString(manuallyLeadForm.clientEmail),
        clientPhoneNumber: nullIfEmptyString(
            manuallyLeadForm.clientPhoneNumber
        ),
        requestZipCode: nullIfEmptyString(manuallyLeadForm.requestZipCode),
        requestRegion: nullIfEmptyString(manuallyLeadForm.requestRegion),
        source: manuallyLeadForm.source,
        productId:
            manuallyLeadForm.productId == undefined
                ? Product.Unbekannt
                : manuallyLeadForm.productId,
        comments: nullIfEmptyString(manuallyLeadForm.comments),
        clientAge: manuallyLeadForm.clientAge?.trim()
            ? Number(manuallyLeadForm.clientAge)
            : undefined,
        clientCareLevel: manuallyLeadForm.clientCareLevel ?? undefined,
        otherInformations: Object.fromEntries(
            manuallyLeadForm.customPropertiesList
                .filter((prop) => {
                    const trimmedKey = (prop.key || "").trim();
                    const trimmedValue = (prop.value || "").trim();
                    return !(trimmedKey === "" && trimmedValue === "");
                })
                .map((prop) => [prop.key, prop.value])
        )
    };
}
